// extracted by mini-css-extract-plugin
module.exports = {"content-update-box":"bedJpMfqdwRM3LmwEK0zTQ==","content-list":"_1RWN1PnKBBpW+bWEMXRPvw=="};